module.exports = __webpack_public_path__ + "static/olamijulo-2a61cc52ff332fc15b1aa372b8b9e74e.png";